<script setup lang="ts">
export interface GrammarLocalLoaderProps {
  text?: string;
}

const props = withDefaults(defineProps<GrammarLocalLoaderProps>(), {
  text: 'Loading',
});
</script>

<template>
  <tpg-local-loader v-bind="props" />
</template>
